import {LegacyPhoneNumberAdaptor} from './legacyPhoneNumberAdaptor.js';
import {PhoneTypeEnum} from '../enums/phoneTypeEnum.js';

export var LegacyPhoneListAdaptor = function(phoneNumbersData) {
    var phoneNumbers = {};
    
    // Constructor
    if (phoneNumbersData) {
        var home = phoneNumbersData.home;
        var mobile = phoneNumbersData.mobile;
        var work = phoneNumbersData.work;
        var fax = phoneNumbersData.fax;
        
        phoneNumbers.phoneList = [];

        if (home) {
            phoneNumbers.phoneList.push(LegacyPhoneNumberAdaptor(PhoneTypeEnum.HOME, home));
        }
        if (mobile) {
            phoneNumbers.phoneList.push(LegacyPhoneNumberAdaptor(PhoneTypeEnum.MOBILE, mobile));
        }
        if (work) {
            phoneNumbers.phoneList.push(LegacyPhoneNumberAdaptor(PhoneTypeEnum.WORK, work));
        }
        if (fax) {
            phoneNumbers.phoneList.push(LegacyPhoneNumberAdaptor(PhoneTypeEnum.FAX, fax));
        }
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------

    return phoneNumbers;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/adaptors/legacyPhoneListAdaptor.js
// module id = 22
// module chunks = 0